import { createElement } from 'react';
import { Link, useLocation, type LinkProps, type NavigateOptions } from 'react-router';
import { getAppRouter } from './app-router';
// Hash links retain the report/search context, matching native anchor semantics.
export function AppLink(props: LinkProps) {
  const { search } = useLocation();
  const to = typeof props.to === 'string' && props.to.startsWith('#') ? { search, hash: props.to } : props.to;
  return createElement(Link, { ...props, to });
}

/** Imperative callers use the same Router as links and browser back/forward. */
export function navigateInApp(href: string, options: NavigateOptions = {}) {
  const url = new URL(href, window.location.origin);
  if (url.origin !== window.location.origin) throw new Error('Internal navigation required');
  const path = `${url.pathname}${url.search}${url.hash}`;
  return getAppRouter().navigate(path, options);
}
